<template>
  <Wrapper :is-loading="isLoading" :background-url="backgroundUrl">
    <slot name="title" />
    <Content>
      <slot name="switcher"></slot>
      <Scroller>
        <Prices :is-loading="isLoading">
          <slot name="prices" />
        </Prices>
      </Scroller>
    </Content>
  </Wrapper>
</template>
<script>
import Wrapper from '@/components/Prices/Layouts/PricesVertical/Wrapper.vue';
import Content from '@/components/Prices/Layouts/PricesVertical/Content.vue';
import Scroller from '@/components/Prices/Layouts/PricesVertical/Scroller.vue';
import Prices from '@/components/Prices/Layouts/PricesVertical/Prices.vue';
export default {
  components: { Wrapper, Content, Scroller, Prices },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    backgroundUrl: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>
